module.exports = __webpack_public_path__ + "img/BannerPortabilidad700x250px.864431a7.jpg";